module.exports = __webpack_public_path__ + "img/ufo-premium.3f8b0c3e.png";